import React from 'react'
import ReactDOM from 'react-dom'
import { firebaseConfig } from './components/Firebase/FirebaseApp'
import { FirebaseAppProvider } from 'reactfire'
import 'firebase/performance'
import App from './components/App/App'

ReactDOM.render(
  <FirebaseAppProvider firebaseConfig={firebaseConfig} initPerformance>
    <App />
  </FirebaseAppProvider>,
  document.getElementById('root')
)
